module.exports = __webpack_public_path__ + "img/yun-icon.82b70778.png";